import React, { Component } from "react";
import { withRouter } from "react-router-dom";

//Redux
import { connect } from "react-redux";
import { updateAuthenticated } from "./../../redux/actions/index";
import { getFaqs } from "../../redux/actions/faqs";

// Styles
import "./Faq.css";

export class Faq extends Component {
  // State
  state = {
    user: this.props.user,
    isAuthenticated: this.props.isAuthenticated,
  };

  // Methods
  toggleModal = () => {
    // Get and display the modal
    document.querySelector("#displayModal").style.display = "block";
  };

  // Life Cycle Hooks
  componentDidMount() {
    // If user is not authenticates, redirect to login
    if (!this.props.isAuthenticated) {
      this.props.history.push("/login");
    }

    document.querySelectorAll(".accordion").forEach((accordion) => {
      accordion.addEventListener("click", function () {
        /* Toggle between adding and removing the "active" class,
            to highlight the button that controls the panel */
        this.classList.toggle("active");
        let panel = this.nextElementSibling;
        if (this.classList.contains("active")) {
          panel.classList.add("show");
        } else {
          panel.classList.remove("show");
        }
      });
    });
  }

  render() {
    return (
      <div className="Faq datatable-wrapper">
        <div className="animated fadeInRight">
          {/*Welcome Block*/}
          <div className="block-header">
            <div className="row">
              <div className="col-lg-12 col-md-6 col-sm-7 dashboard-title faq-title">
                <h3 className="m-l-1">
                  <aside className="rounder">
                    <i className="fa fa-question" />
                  </aside>
                  &nbsp; Frequently Asked Questions
                </h3>
              </div>
            </div>
          </div>

          {/*Accordion*/}
          <div className="grid__padding mt-30">
            {questions.map((question, index) => {
              return (
                <div key={index} className="m-b-1">
                  <button className="accordion">
                    {question.title}
                    <i className="fa fa-plus" />
                  </button>
                  <div className="panel animated fadeInDown">
                    <p>{question.content}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

const questions = [
  {
    title: "How does Advancly work?",
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing " +
      "elit. Etiam sit amet molestie mauris. Maecenas justo ligula" +
      ", maximus sit amet congue in, pretium sit amet purus. " +
      "Nullam convallis dictum est, at posuere libero venenatis " +
      "et. Aliquam erat volutpat. Mauris vitae elit leo. Vivamus " +
      "sit amet dignissim le, elementum venenatis mi. ",
  },
  {
    title: "Why does Advancly require both my email and phone number?",
    content:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam sit amet molestie mauris. Maecenas justo ligula, maximus sit amet congue in, pretium sit amet purus. Nullam convallis dictum est, at posuere libero venenatis et. Aliquam erat volutpat. Mauris vitae elit leo. Vivamus sit amet dignissim leo, nec pellentesque tortor. Nam quis vehicula tortor. Suspendisse sit amet posuere sapien, elementum venenatis mi. Aenean rutrum et nulla in ultrices. Curabitur vitae mi ac ligula mattis rhoncus. Proin eget diam sed odio porttitor bibendum. In faucibus urna a neque feugiat, at dapibus odio consequat.",
  },
  { title: "What is behavioural rating?", content: "" },
  { title: "How can i improve my behavioural rating?", content: "" },
  { title: "What is credit score rating?", content: "" },
  { title: "How can i improve my credit score rating?", content: "" },
  { title: "How can i improve my behavioural rating?", content: "" },
  { title: "How can i improve my behavioural rating?", content: "" },
];

const mapStateToProps = (state) => {
  const { isAuthenticated, loggedInUser } = state.authReducer;
  const { faq } = state.faqReducer;
  return {
    isAuthenticated,
    loggedInUser,
    faq,
  };
};

export default connect(mapStateToProps, { updateAuthenticated, getFaqs })(
  withRouter(Faq)
);
